<template>
  <div>
    <footer class="footer-main">
      <div class="container">
        <div class="row mb-4">
          <div class="col-md-6 ml-auto mr-auto small">
            <p>
              No Purchase Necessary. Open 1/1/24 - 12/31/24 to US residents, 18 and older. See
              <a style="display: none;" href @click.prevent="$router.app.$emit('showRulesModal')"
                ><strong>Official Rules</strong></a
              >
              <a href="https://rules.promosis.com/share" target="_blank">Official Rules</a>
              for details.
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <p class="small">
              &copy; {{ new Date().getFullYear() }} Tempur-Pedic North America,
              LLC. All Rights Reserved. &nbsp;
              <a
                href="https://www.tempurpedic.com/legal/terms-of-use/"
                target="_blank"
                >Terms of Use</a
              >
              &nbsp;
              <a
                href="https://www.tempurpedic.com/legal/privacy-policy/"
                target="_blank"
                >Privacy Policy</a
              >
              &nbsp;

              <a
                href="http://www.youtube.com/tempurpedic"
                class="firstSocialFooterIcon"
                aria-label="Visit TempurPedic on YouTube."
                ><i class="fa-brands fa-youtube fa-fw"></i
              ></a>

              <a
                href="https://www.facebook.com/TempurPedic"
                aria-label="Visit TempurPedic on Facebook."
                ><i class="fa-brands fa-facebook fa-fw"></i
              ></a>

              <a
                href="https://twitter.com/tempurpedic"
                aria-label="Visit TempurPedic on Twitter."
                ><i class="fa-brands fa-x-twitter fa-fw"></i
              ></a>

              <a
                href="http://www.pinterest.com/tempurpedic"
                aria-label="Visit TempurPedic on Pinterest."
                ><i class="fa-brands fa-pinterest fa-fw"></i
              ></a>

              <a
                href="https://instagram.com/tempurpedic/"
                aria-label="Visit TempurPedic on Instagram."
                ><i class="fa-brands fa-instagram fa-fw"></i
              ></a>
            </p>
          </div>
        </div>
      </div>
    </footer>

    <rules-modal></rules-modal>
  </div>
</template>

<script>
export default {
  name: "footer-main",
  data() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/app.scss";

.footer-main {
  position: relative;
  height: auto;
  text-align: center;
  transition: $transition;
  background-color: $dark-grey;
  color: $white;
  padding: 22px 0 10px;
  line-height: 1.8;

  a {
    text-decoration: none;
    color: $white;

    &::hover {
      color: lighten($blue, 35%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/Main/Footer.vue